import React from 'react';
import { CTABand } from '../../components/CTABand';
export function ReviewsFinalCTA() {
  return <CTABand headline="Ready to Write Your Own Success Story?" copy="Join the families who have found confidence, fitness, and community at Storm Taekwondo." data-id="element-2925" />;
}